import { RouteLocationNormalized } from 'vue-router';

export const ERROR_GUARD = async (error: any, to: RouteLocationNormalized) => {
   const fatalErrors = ['Failed to fetch dynamically imported module', 'Importing a module script failed'];

   if (fatalErrors.some((fatalError) => error.message.includes(fatalError))) {
      window.location.replace(to.fullPath);
   }
};
